import * as autosize from "autosize";
import axios from "axios";
import { createApp } from "vue";
import App from "./App.vue";
import { config } from "./config.js";
import router from "./router";
import store from "./store";

import { CkeditorPlugin } from "@ckeditor/ckeditor5-vue";
import ImageMarkupConfigControl from "./components/ImageTemplate/ImageMarkupConfigControl";
import ImageMarkupControl from "./components/ImageTemplate/ImageMarkupControl";
if (typeof window !== "undefined") {
  window.CKEDITOR_VERSION = "42.0.2";
}

import fetchIntercept from "fetch-intercept";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "vue3-color-gradient-picker/dist/style.css";

import { VueFormBuilderPlugin } from "@ray-solutions/v-form-builder";
import "@ray-solutions/v-form-builder/dist/v-form-builder.css";

import "vue-multiselect/dist/vue-multiselect.min.css";
import VueSweetalert2 from "vue-sweetalert2";

import AppDatePicker from "@/components/AppDatePicker.vue";
import BaseModal from "@/components/BaseModal.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import "bootstrap";
import Cleave from "cleave.js";
import $ from "jquery";
import "@/plugins/jquery.maphilight.js";
import "popper.js";
import Swal from "sweetalert2";
import { createVfm } from "vue-final-modal";
import "vue-final-modal/style.css";
import VueApexCharts from "vue3-apexcharts";
import PermissionsPlugin from "./plugins/permissions";
import filters from "./utils/filters";

window.$ = window.jQuery = $;

window.onbeforeprint = () => {
  const textareas = document.querySelectorAll(".vue-form-renderer textarea");
  textareas.forEach((textarea) => {
    const div = document.createElement("div");
    div.className = "print-textarea-div form-control";
    if (textarea.classList.contains("rounded-0")) {
      div.classList.add("rounded-0", "min-h40");
    }
    div.textContent = textarea.value;
    textarea.parentNode.insertBefore(div, textarea.nextSibling);
  });
  window.$(".client-notes .vue-form-renderer .multi-select").each(function () {
    window.$(this).find(".option:not(.selected)").hide();
    window.$(this).css("min-height", "60px");
  });
};

window.onafterprint = () => {
  const divs = document.querySelectorAll(".print-textarea-div");
  divs.forEach((div) => {
    div.parentNode.removeChild(div);
  });
  window.$(".client-notes .vue-form-renderer .multi-select").each(function () {
    window.$(this).find(".option:not(.selected)").show();
  });
};

const resizeObserverErr = window.console.error;
window.console.error = (...args) => {
  if (args[0]?.includes?.("ResizeObserver")) return;
  resizeObserverErr(...args);
};

config.loadConfig().then((configResult) => {
  store.state["appConfig"] = configResult;

  const app = createApp(App);
  app.config.productionTip = false;

  app.config.errorHandler = (err, instance, info) => {
    console.error("[Vue 3 Error]:", err, info);
  };

  app.config.warnHandler = (msg) => {
    if (msg.includes("vue-advanced-chat") || msg.includes("itemKey")) return;
    console.warn("[Vue 3 Warning]:", msg);
  };

  const httpClient = axios.create({
    baseURL: `${configResult.api}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  httpClient.interceptors.request.use((config) => {
    if (window.Echo) {
      config.headers["X-Socket-ID"] = window.Echo.socketId();
    }
    const token = localStorage.getItem("ARSS_TOKEN");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  });

  httpClient.interceptors.response.use(
    (res) => res,
    (error) => {
      if (error.response) {
        if (
          (error.response.data.error || {}).message == "Access denied" ||
          (error.response.data.error || {}).message ==
            "This action is unauthorized."
        ) {
          Swal.fire({
            title: "Access Denied",
            html: "Looks like your permissions weren't properly configured for some areas of the app, please contact the admin at <a href='mailto:support@communitycareconnection.com'>support@communitycareconnection.com</a> to fix this.",
            icon: "error",
          }).then(() => {
            if (
              error.response?.data?.error?.route?.methods[0] === "GET" ||
              error.response?.data?.debug?.route?.methods[0] === "GET"
            ) {
              window.location.href = "/";
            }
          });

          return Promise.reject({ accessDenied: true });
        }

        if (
          (error.response.data.error || {}).message == "Service Unavailable"
        ) {
          Swal.fire({
            title: "Maintenance Mode",
            html: "We are currently performing maintenance on the server, please try again later.",
            icon: "error",
          }).then(() => {
            if (window.location.path != "/login") {
              localStorage.removeItem("ARSS_TOKEN");
              localStorage.removeItem("USER_TYPE");
              localStorage.removeItem("C3_LOGIN");
              window.location.href = "/login";
            }
          });
          return Promise.reject({ accessDenied: true });
        }

        if (
          ((error.response.data || {}).error || {}).message ==
            "Unauthenticated." ||
          ((error.response.data || {}).error || {}).message == "token expired"
        ) {
          if (window.location.path != "/login") {
            localStorage.removeItem("ARSS_TOKEN");
            localStorage.removeItem("USER_TYPE");
            localStorage.removeItem("C3_LOGIN");
            window.location.href = "/login";
          }
          return Promise.reject();
        }
        return Promise.reject(error.response);
      }

      return Promise.reject(error);
    }
  );

  app.use(VueFormBuilderPlugin, {
    controls: {
      imageMarkup: {
        name: "Image Drawer",
        description: "Image Markup Editor (Draw & Paint)",
        fieldComponent: ImageMarkupControl,
        configComponent: ImageMarkupConfigControl,
        configData: {
          canvasWidth: 400,
          canvasHeight: 400,
          hasImageBorder: true,
          imagePosition: "left",
          containerClass: "col-md-12 md-layout-item md-size-100",
          imageUrl: "",
        },
        rendererDefaultData() {
          return false;
        },
      },
    },
  });

  fetchIntercept.register({
    request: function (url, config) {
      const token = localStorage.getItem("ARSS_TOKEN");
      if (token && config && url.includes(configResult.api)) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
      }
      return [url, config];
    },
  });

  app.config.globalProperties.$http = httpClient;
  app.config.globalProperties.$ = $;

  store.$http = httpClient;

  const vfm = createVfm({
    defaultProps: {
      overlayClass: "d-flex justify-content-center align-items-center",
    },
  });
  app.use(vfm);

  app.component("modal", BaseModal);
  app.component("apexchart", VueApexCharts);
  app.config.globalProperties.$vfm = vfm;

  app.use(VueSweetalert2);
  app.component("VueDatePicker", AppDatePicker);

  app.use(CkeditorPlugin);

  // `touch` rather than a width check: the width was read once at startup, so loading in a
  // narrow window left every tooltip in the app click-only for the whole session, and widening
  // it again never brought hover back.
  app.use(FloatingVue, {
    themes: {
      tooltip: {
        triggers: ["hover", "focus", "touch", "click"],
      },
    },
  });

  const files = require.context("./components/", true, /\.vue$/i);
  files.keys().map((key) => {
    const componentName = key.split("/").pop().split(".")[0];
    app.component(componentName, files(key).default);
  });

  app.directive("autosize", {
    mounted: (el) => {
      setTimeout(function () {
        autosize(el);
      }, 0);
    },
  });

  app.directive("cleave", {
    mounted: (el, binding) => {
      if (binding.value) {
        el.cleave = new Cleave(el, binding.value || {});
      }
    },
    updated: (el) => {
      if (typeof el.cleave !== "undefined") {
        const event = new Event("input", { bubbles: true });
        setTimeout(function () {
          if (el.cleave.properties.result) {
            el.value = el.cleave.properties.result;
            el.dispatchEvent(event);
          }
        }, 100);
      }
    },
  });

  app.config.globalProperties.$filters = filters;
  app.config.globalProperties.$customerLabel = filters.customerLabel;
  app.config.globalProperties.$providerLabel = filters.providerLabel;
  app.config.globalProperties.$clinicLabel = filters.clinicLabel;
  app.config.globalProperties.$programLabel = filters.programLabel;
  app.config.globalProperties.$isActiveUserStatus = filters.isActiveUserStatus;

  app.use(PermissionsPlugin, { store });

  app.use(router);
  app.use(store);

  app.mount("#app");
});
